import { calendarProfileImageUrl } from "src/utils/imageUrl.js";

// Keep this in module scope so separate rails do not ask the browser to warm
// the same profile art repeatedly during one visit.
const warmedSources = new Set();

/**
 * Starts low-cost browser fetches for art that is about to enter a rail. This
 * deliberately warms only the rail's visual window; data deeper in the buffer
 * remains cheap until it gets close to the viewport.
 *
 * @param {Array<object>} calendars
 */
export const warmCalendarImages = (calendars) => {
  if (typeof Image === "undefined") return;

  calendars.forEach((calendar) => {
    const src = calendarProfileImageUrl(calendar);
    if (!src || warmedSources.has(src)) return;

    warmedSources.add(src);
    const image = new Image();
    image.decoding = "async";
    image.src = src;
  });
};
